import { Button, Calendar, Checkbox, DatePicker, Form, message, Modal, Tag } from "antd";
import dayjs from "dayjs";
import locale from "dayjs/locale/ru";
import { useEffect, useState } from "react";
import "./records-copy.css";
import { serverFetch } from "../../server";
import { isMobile } from '@extensions/design';

// Настраиваем dayjs для использования русской локали с началом недели с понедельника
dayjs.locale(locale);

const RecordsCopy = ({ onClose, items, selectedLabels = {} }) => {
  const [loading, setLoading] = useState(false);
  const [dates, setDates] = useState([]);
  const [form] = Form.useForm();
  const [currentPanelValue, setCurrentPanelValue] = useState(dayjs());
  const [isPanelChanging, setIsPanelChanging] = useState(false);
  const [createLinkedChain, setCreateLinkedChain] = useState(true);
  const [copyClients, setCopyClients] = useState(false);

  // Если выбрано несколько записей, сбрасываем и блокируем опцию связанной цепочки
  useEffect(() => {
    if (items.length > 1) {
      setCreateLinkedChain(false);
    }
  }, [items.length]);

  const onSave = () => {
    setLoading(true);
    const data = {
      dates: dates.map(i => i.format("YYYY-MM-DD")),
      source: items,
      createLinkedChain: createLinkedChain,
      copyClients: copyClients,
    };
    serverFetch("Record/Paste", {method: "POST", bodyData: data})
      .then(() => {
        message.success("Запись успешно скопирована");
        onClose(true);
      })
      .catch(e => {
        message.error(e.userMessage);
        setLoading(false);
      });
  }

  const onPanelChange = (value) => {
    // Отмечаем, что происходит смена панели
    setIsPanelChanging(true);
    setCurrentPanelValue(value);
    // Сбрасываем флаг через небольшую задержку
    setTimeout(() => setIsPanelChanging(false), 100);
  }

  const onSelect = value => {
    // Игнорируем вызовы onSelect во время смены панели (месяца/года)
    if (isPanelChanging) {
      return;
    }
    
    // Проверяем, что выбранная дата находится в текущем отображаемом месяце
    if (value.month() !== currentPanelValue.month() || value.year() !== currentPanelValue.year()) {
      return;
    }
    
    if (dates.find(i => i.format("DD-MM-YYYY") === value.format("DD-MM-YYYY")))
      setDates([...dates.filter(i => i.format("DD-MM-YYYY") !== value.format("DD-MM-YYYY"))]);
    else
      setDates([...dates, value]);
  }

  const onRender = value => {
    const className = "records-copy" + (dates.find(i => i.format("DD-MM-YYYY") === value.format("DD-MM-YYYY")) ? " records-copy-selected" : "");
    return<div className={className}>{value.format("D")}</div>
  }

  // Плашки выбранных дней: клик по крестику убирает день из списка (и снимает выделение в календаре)
  const divTags = [...dates].sort((a, b) => a - b).map(i => (
    <Tag
      key={i}
      closable
      onClose={e => {
        // Предотвращаем штатное скрытие плашки — удаляем день из состояния
        e.preventDefault();
        setDates(dates.filter(d => d.format("DD-MM-YYYY") !== i.format("DD-MM-YYYY")));
      }}
    >
      {i.format("DD.MM.YY")}
    </Tag>
  ))

  const hasAnyExecutor = items.some(id => selectedLabels[id]?.name);

  return <Modal title="Копирование записей" open
    onCancel={() => onClose(false)}
    footer={[
      <Button key="submit" type="primary" className="sport-btn" loading={loading} onClick={onSave}>ОК</Button>,
      <Button key="back" onClick={() => onClose(false)}>Отмена</Button>
    ]}
  >
    <Form form={form} colon={false}>
      {!isMobile ? <div className="records-copy-section">
        <div className="records-copy-section-label">Выбранные записи</div>
        {items.length ? <Form.Item className="records-copy-items-form-item"><div className="records-copy-items-grid">{items.map(id => {
          const label = selectedLabels[id];
          if (!label) return null;
          return (
            <Tag key={id} className={`records-copy-record-tag${hasAnyExecutor ? ' records-copy-record-tag--equal' : ''}`}>
              <span className="records-copy-record-date">{label.dateTime}</span>
              {label.name ? <span className="records-copy-record-name">{label.name}</span> : null}
            </Tag>
          );
        })}</div></Form.Item> : null}
      </div> : null}
      <div className="records-copy-section">
        <div className="records-copy-section-label">Выбранные дни</div>
        <Form.Item>{divTags}</Form.Item>
      </div>
      <Form.Item>
        <Calendar
          fullscreen={false}
          mode="month"
          onSelect={onSelect}
          onPanelChange={onPanelChange}
          disabledDate={date => date < dayjs().startOf('day')}
          fullCellRender={onRender}
          headerRender={({ value, onChange }) => (
            <div style={isMobile ? { marginTop: 16} : {marginBottom: 16, marginTop: 18}}>
              <DatePicker
                picker="month"
                value={value}
                onChange={(v) => { if (v) { onChange(v); onPanelChange(v); } }}
                allowClear={false}
                format="MMMM YYYY"
              />
            </div>
          )}
        />
      </Form.Item>
       <Form.Item>
         <Checkbox 
           checked={createLinkedChain} 
           onChange={(e) => setCreateLinkedChain(e.target.checked)}
           disabled={items.length > 1}
         >
           Создать как связанную цепочку
         </Checkbox>
       </Form.Item>
      <Form.Item>
        <Checkbox checked={copyClients} onChange={(e) => setCopyClients(e.target.checked)}>
          Копировать клиентов записи
        </Checkbox>
      </Form.Item>
    </Form>
  </Modal>
}

export default RecordsCopy;